import { memo, useCallback, type ChangeEvent } from 'react';
import { useTheme } from '@/contexts/ThemeContext';
import type { FormFieldBaseProps } from './field-base';

export interface TextFieldProps extends FormFieldBaseProps<string | null | undefined> {}

export const TextField = memo(function TextField({
  field,
  value,
  onChange,
  readOnly = false,
  error,
}: TextFieldProps) {
  const { theme } = useTheme();

  const handleChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      onChange(e.target.value);
    },
    [onChange],
  );

  const errorId = error ? `${field.key}__error` : undefined;
  return (
    <div className={'form-group text-field' + (theme ? ' ' + theme : '') + (error ? ' has-error' : '')}>
      <label className={'field-label' + (field.required ? ' required' : '')} htmlFor={field.key}>
        {field.label}
      </label>
      <input
        id={field.key}
        name={field.key}
        type="text"
        className={'kstc-input form-input' + (error ? ' form-input--error' : '')}
        value={value ?? ''}
        onChange={handleChange}
        disabled={readOnly}
        required={field.required === true}
        title={error || undefined}
        aria-invalid={error ? true : undefined}
        aria-describedby={errorId}
      />
      {error ? <div id={errorId} className="form-field-error" role="alert">{error}</div> : null}
    </div>
  );
});
